<template>
    <div class="overflow-y-auto lg:overflow-auto">
        <div class="lg:hidden text-xl text-link font-semibold pb-4">
            {{ t('product.tabsAdditionalInformations.title') }}
        </div>

        <div class="text-lg" v-html="customFields?.additional_information" />
    </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps<{
    customFields?: object | undefined
}>()
</script>
